module.exports = __webpack_public_path__ + "img/htkj_05.e3936a75.jpg";